// Services use host ports. Resolve localhost against the browser's host so the
// same frontend also works when opened from another machine on the network.
export const serviceUrl = (url) => {
  const parsed = new URL(url);
  if (parsed.hostname === 'localhost' || parsed.hostname === '127.0.0.1') {
    parsed.hostname = window.location.hostname;
  }
  return parsed.toString().replace(/\/$/, '');
};

export const fileServerUrl = serviceUrl(process.env.REACT_APP_FILE_SERVER_URL || 'http://localhost:8080');
